import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M24 0H0V24H24V0Z" fill="white" fillOpacity="0.01" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1C11.5762 1 11.2326 1.3436 11.2326 1.76744C11.2326 2.19129 11.5762 2.53488 12 2.53488C17.2274 2.53488 21.4651 6.77256 21.4651 12C21.4651 17.2274 17.2274 21.4651 12 21.4651C6.77256 21.4651 2.53488 17.2274 2.53488 12C2.53488 11.5762 2.19129 11.2326 1.76744 11.2326C1.3436 11.2326 1 11.5762 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM12 5.09302C8.18538 5.09302 5.09302 8.18538 5.09302 12C5.09302 15.8146 8.18538 18.907 12 18.907C12.4238 18.907 12.7674 18.5634 12.7674 18.1395C12.7674 17.7157 12.4238 17.3721 12 17.3721C9.03308 17.3721 6.62791 14.9669 6.62791 12C6.62791 9.03308 9.03308 6.62791 12 6.62791C14.9669 6.62791 17.3721 9.03308 17.3721 12C17.3721 12.4238 17.7157 12.7674 18.1395 12.7674C18.5634 12.7674 18.907 12.4238 18.907 12C18.907 8.18538 15.8146 5.09302 12 5.09302Z"
      fill="currentColor"
    />
  </svg>
);
